import React, { Component } from 'react'
import styled from 'styled-components'
import { graphql, compose, withApollo } from 'react-apollo'
import Button from '../../common/Button'
import LoadingButton from '../../common/LoadingButton'
import DestroyBankCommentary from '../queries/DestroyBankCommentary'
import DestroyReply from '../queries/DestroyReply'

const Container = styled.div`
  border: 1px solid #b4b5b6;
  background: white;
  border-radius: 5px;
  padding: 30px;
  color: #666666;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 216px;
  width: 380px;
`
const Title = styled.h3`
height: 22px;
width: 295px;
color: #616165;
font-family: "Open Sans";
font-size: 16px;
letter-spacing: 0.41px;
line-height: 22px;
text-align: center;
margin-bottom: 50px;
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
const Cancel = Button.extend`
  background: #b4b5b6;
  width: 84px;
  color: #56565A;
  margin-right: 25px;
`
const Delete = styled(LoadingButton)`
  margin-left: 25px;
  width: 84px;
  color: #FFFFFF;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.36px;
  line-height: 19px;
  text-align: center;
  background-color: #BC3C4B;
`

class DeleteCommentryConfirmationModal extends Component {
  constructor() {
    super()
    this.state = {
      isLoading: false
    }
  }

  deleteBankCommentry = async () => {
    const { deleteQuestionId, destroyBankCommentary, updateQuestionsList } = this.props

    try {
      await destroyBankCommentary({
        variables: {
          input: {
            bankCommentaryId: deleteQuestionId
          }
        }
      })
      updateQuestionsList()
    } catch (err) {
      console.error(err)
    }
  }

  deleteReply = async () => {
    const { deleteReplyId, destroyReply, toggleModal, updateReplyList } = this.props

    try {
      await destroyReply({
        variables: {
          input: {
            replyId: deleteReplyId
          }
        },
        update: async (store, { data: { destroyReply: { reply: { rid, bankCommentary } } } }) => {
          updateReplyList(bankCommentary.rid, rid);
          toggleModal()
        }
      })
    } catch (err) {
      console.error(err)
    }
  }

  onDeleteClick = () => {
    const { deleteQuestionId, deleteReplyId } = this.props

    if (deleteQuestionId !== null){
      this.deleteBankCommentry()
    } else if (deleteReplyId !== null) {
      this.deleteReply()
    }
  }

  render() {
    const { toggleModal } = this.props
    const { isLoading } = this.state

    return (
      <Container>
        <Title>Are you sure you want to delete this?</Title>
        <ButtonContainer>
          <Cancel onClick={toggleModal}>
            Cancel
          </Cancel>
          <Delete loading={isLoading} onClick={this.onDeleteClick}>
            Delete
          </Delete>
        </ButtonContainer>
      </Container>
    )
  }
}

export { DeleteCommentryConfirmationModal }

export default compose(
  graphql(DestroyBankCommentary, {
    name: 'destroyBankCommentary'
  }),
  graphql(DestroyReply, {
    name: 'destroyReply'
  }),
  withApollo
)(DeleteCommentryConfirmationModal)
